import { useState } from "react";
import { toast } from "sonner";
import { Eye, Loader2 } from "lucide-react";
import { api, mediaUrl, formatApiError } from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import { InlineLoader } from "@/components/LoadingScreen";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const FinalPreview = ({ getBody, testid = "real-preview-btn", className, label }) => {
  const { t } = useI18n();
  const [preview, setPreview] = useState(null);
  const run = async () => {
    setPreview({ loading: true });
    try {
      const { data } = await api.post("/clips/preview", getBody());
      setPreview({ id: data.id });
    } catch (e) { toast.error(formatApiError(e)); setPreview(null); }
  };
  return (
    <>
      <button data-testid={testid} onClick={run} disabled={!!preview?.loading}
        className={className || "cx-ghost w-full rounded-full py-2.5 text-xs text-white flex items-center justify-center gap-2"}>
        {preview?.loading ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Eye className="w-3.5 h-3.5 text-[#3ad7ff]" />} {label || t("fx.preview")}
      </button>
      <Dialog open={!!preview} onOpenChange={(o) => !o && setPreview(null)}>
        <DialogContent className="bg-[#0b0e1a] border-white/10 max-w-md" data-testid="real-preview-dialog">
          <DialogHeader><DialogTitle className="font-display text-white">{t("fx.preview_title")}</DialogTitle></DialogHeader>
          <div className="grid place-items-center bg-black rounded-lg min-h-[300px] max-h-[70vh] overflow-hidden">
            {preview?.id ? <video src={mediaUrl(`/clips/preview/${preview.id}`)} autoPlay loop controls playsInline className="max-h-[70vh] w-full object-contain" data-testid="real-preview-video" /> : <InlineLoader label={t("fx.preview_loading")} />}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
